<template>
  <div>
    <modal :show="showNotice" @closeModal="AnnouncementClosed">
      <h2 class="border-b -mx-4 px-4 pb-2">Announcement<span v-if="announcements.length > 1">s</span></h2>
        <div v-for="msg in announcements" class="py-3 mb-1 px-2">
            <h3 class="text-lg font-bold mb-1">{{ msg.title }}</h3>
            <p class="text-xs text-gray-500">Date {{ msg.start_date | localDate }}</p>
            <div v-html="msg.body" class="mt-2 text-black antialiased leading-6"></div>
        </div>
      <div class="text-center border-t mt-3 pt-2">
        <a href="#" @click="AnnouncementClosed">close me</a>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '@/Shared/Modal'
export default {
  name: 'AnnoucementsNotification',
  components: { Modal },

  data() {
    return {
      showNotice: false,
      announcements: []
    }
  },

  beforeMount() {
    this.fetchNotifications();
  },

  methods: {
    AnnouncementClosed(evt) {
      this.showNotice = false;
      if(this.announcements.length > 0) {
        this.announcements.forEach(notice => {
          if(notice.show_until_dismissed) {
            this.$http.get(this.route('ajax.customer.dismiss-announcement', {announcement: notice.id}));
          }
        })
      }
    },

    fetchNotifications() {
      this.$http.get(this.route('ajax.customer.announcements')).then(response => {
        this.announcements = response.data.data
        if(this.announcements.length > 0) {
          this.showNotice = true
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
